<template>
  <div class="all">
    <button class="btn btn-lg btn-outline-primary"
      @click="loginClick()" type="submit">
      <i class="fab fa-google"></i> 使用google繼續
    </button>
  </div>
</template>

<script>
import firebase from 'firebase/app';

export default {
  methods: {
    loginClick() {
      const fireAuth = firebase.auth();
      const vm = this;

      // Start a sign in process for an unauthenticated user.
      const provider = new firebase.auth.GoogleAuthProvider();
      provider.addScope('profile');
      provider.addScope('email');
      fireAuth.signInWithPopup(provider).then((result) => {
        const user = { user: result.user }; // 檢測
        const userUid = firebase.database().ref(`/users/${user.uid}`).once('value').then(snapshot => snapshot.displayName);
        if (typeof userUid !== 'string') {
          // 沒登過，寫入會員基本資料
          firebase.database().ref(`users/${user.uid}`).set({
            email: user.email,
            displayName: user.displayName,
            photoURL: user.photoURL,
          });
          vm.$router.push('/');
        }
      }).catch((ero) => {
        // 處理 帳號已經存在於其他登入方式時
        if (ero.code === 'auth/account-exists-with-different-credential') {
          // 取得當初此Email的登入方式
          const { email } = ero;
          console.log('google登入錯誤-使用者信箱：', email);
        }
      });
    },
  },
  created() {
    let userStr;
    firebase.auth().onAuthStateChanged((userState) => {
      if (userState) {
        userStr = userState;
        console.log('User is logined', userStr);
      } else {
        userStr = null;
        console.log('User is not logined yet.');
      }
    });
  },
};
</script>

<style lang="scss" scoped>
.all {
  height: 100vh;
}

.all {
  display: -ms-flexbox;
  display: -webkit-box;
  display: flex;
  -ms-flex-align: center;
  -ms-flex-pack: center;
  -webkit-box-align: center;
  align-items: center;
  -webkit-box-pack: center;
  justify-content: center;
  padding-top: 40px;
  padding-bottom: 40px;
  background-color: #f5f5f5;
}
</style>
